import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export interface IMajorInterest {
  id: number;
  nk: string;
  title: string;
  _selected: boolean;
}

export interface IMajorInterestCollection {
  activityinterest: IMajorInterest[];
  subjectinterest: IMajorInterest[];
}

export interface IMajorUserListSelections {
  max_interests: number;
  activityinterest: number[];
  subjectinterest: number[];
}

export class MajorListSelectionBuilder implements IIndexable {
  id: number;
  interests: IMajorInterestCollection;
  listselections: IMajorUserListSelections;
  activityinterestSorted: IMajorInterest[];
  subjectinterestSorted: IMajorInterest[];

  constructor(selection: MajorListSelectionBuilder) {
    this.sortByTitle(selection);
    this.setSelectedInterests(selection);
    _4.merge(this, selection);
  }

  static build(selection: MajorListSelectionBuilder): MajorListSelectionBuilder {
    return new MajorListSelectionBuilder(selection);
  }

  sortByTitle(selection: MajorListSelectionBuilder): void {
    selection.activityinterestSorted = _4.sortBy(_4.toArray(selection.interests.activityinterest), 'title');
    selection.subjectinterestSorted = _4.sortBy(_4.toArray(selection.interests.subjectinterest), 'title');
  }

  setSelectedInterests(selection: MajorListSelectionBuilder): void {
    _4.forEach(selection.listselections.activityinterest, (activityid: number) => {
      const interest = _4.find(selection.activityinterestSorted, { id: activityid });
      if (!_4.isEmpty(interest)) {
        interest._selected = true;
      }
    });

    _4.forEach(selection.listselections.subjectinterest, (subjectid: number) => {
      const interest = _4.find(selection.subjectinterestSorted, { id: subjectid });
      if (!_4.isEmpty(interest)) {
        interest._selected = true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/builders/major_listselection_builder.ts